import React, { useEffect, useState } from 'react';
import TableCrud from '../../components/TableCrud';
import Api, { exceptionNotificationAPI } from '../../services/api';

const RecommendationIndex = () => {
    const [isVisible, setIsVisible] = useState(false);

    const columns = [
        {
            label: "Descrição",
            name: "description"
        },
        {
            label: "Empresa",
            name: "tenant.name",
            visible: isVisible
        },
        {
            label: "Tipo",
            name: "type"
        },
        {
            label: "Unidade de medida",
            name: "unitOfMeasure.description"
        },
        {
            label: "Ativo",
            name: "isActive"
        },
    ]

    const loadData = async () => {
        Api.get('Tenant/isTenant').then((result) => {
            if (result.data.response) {
                setIsVisible(true)
            }
            else{
                setIsVisible(false)      
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <TableCrud title={"Itens de Recomendação"} table={"recommendation"} columns={columns}/>
    );
}

export default RecommendationIndex;
